import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';


@Component({
    selector: 'app-multiple-file-upload-box',
    templateUrl: 'multiple-file-upload-box.html',
    styleUrls: ['./multiple-file-upload-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MultipleFileUploadBoxDialog {

    Files: File[] = [];


    constructor(
        public dialogRef: MatDialogRef<MultipleFileUploadBoxDialog>) {

    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onFileChange(event: any) {

        const files = event.srcElement.files as File[];
        if (files) {
            this.Files.push(...Array.from<File>(files));
        }
        this.Files = _.uniqBy(this.Files, 'name');
    }

    onFileFromDragNDrop(event: any) {
        let files = event instanceof FileList ? event : event.files;

        for (let index = 0; index < files.length; index++) {
            const element = files[index];
            this.Files.push(element);
        }
        this.Files = _.uniqBy(this.Files, 'name');
    }

    remove(file: File): void {
        const index = this.Files.indexOf(file);

        if (index >= 0) {
            this.Files.splice(index, 1);
        }
    }

    addDocument() {
        this.dialogRef.close(this.Files);
    }
}
